import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';
import PreprimarySidebar2025 from '../PreprimarySidebar2025/PreprimarySidebar2025';


const FancyDress2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/10.webp`;
  const p11 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/14.webp`;
const p15 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/15.webp`;
const p16 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/16.webp`;
const p17 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/17.webp`;
const p18 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/18.webp`;
const p19 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/19.webp`;
const p20 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/20.webp`;
const p21 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/21.webp`;
const p22 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/22.webp`;
const p23 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/23.webp`;
const p24 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/24.webp`;
const p25 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/25.webp`;
const p26 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/26.webp`;
const p27 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/27.webp`;
const p28 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/28.webp`;
const p29 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/29.webp`;
const p30 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/30.webp`;
const p31 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/31.webp`;
const p32 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/32.webp`;
const p33 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Fancy/33.webp`;

 

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},
{
    src: p15,
    source: p15,
    rows: 1,
    cols: 1,
},
{
    src: p16,
    source: p16,
    rows: 1,
    cols: 1,
},
{
    src: p17,
    source: p17,
    rows: 1,
    cols: 1,
},
{
    src: p18,
    source: p18,
    rows: 1,
    cols: 1,
},
{
    src: p19,
    source: p19,
    rows: 1,
    cols: 1,
},
{
    src: p20,
    source: p20,
    rows: 1,
    cols: 1,
},
{
    src: p21,
    source: p21,
    rows: 1,
    cols: 1,
},
{
    src: p22,
    source: p22,
    rows: 1,
    cols: 1,
},
{
    src: p23,
    source: p23,
    rows: 1,
    cols: 1,
},
{
    src: p24,
    source: p24,
    rows: 1,
    cols: 1,
},
{
    src: p25,
    source: p25,
    rows: 1,
    cols: 1,
},
{
    src: p26,
    source: p26,
    rows: 1,
    cols: 1,
},
{
    src: p27,
    source: p27,
    rows: 1,
    cols: 1,
},
{
    src: p28,
    source: p28,
    rows: 1,
    cols: 1,
},
{
    src: p29,
    source: p29,
    rows: 1,
    cols: 1,
},
{
    src: p30,
    source: p30,
    rows: 1,
    cols: 1,
},
{
    src: p31,
    source: p31,
    rows: 1,
    cols: 1,
},
{
    src: p32,
    source: p32,
    rows: 1,
    cols: 1,
},
{
    src: p33,
    source: p33,
    rows: 1,
    cols: 1,
}


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Fancy dress
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: PRE-PRIMARY Date: 25 July 2025  

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “When children pretend, they become everything they dream. – Fred Rogers”

<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        On Friday, 25th July 2025, our Pre-Primary children stepped into a world of imagination and creativity as they participated in a joyful Fancy Dress Day. The environment buzzed with excitement as the children prepared to become their chosen characters and speak in front of their classmates and teachers.  
       <br></br>
        <strong>Sparkle, speak, and shine—it’s showtime!</strong> 
        <br></br>
        The Fancy Dress event was a much-awaited occasion for our little ones. With colourful costumes, bright smiles, and bubbling enthusiasm, they truly brought their characters to life. This wonderful experience not only sparked their creativity but also helped them understand the world around them. Preparing for their acts gave them the chance to learn new words and ideas, expanding both their vocabulary and their confidence.
        <br></br>
        <strong>Tiny Talents, Big Themes: A Montessori Showcase of Imagination</strong>
       <br></br>
        Each Montessori environment brought its own unique flair to the Fancy Dress Day, with imaginative themes thoughtfully aligned to the children’s age and developmental levels. From the beauty of Mother Nature and the wonders of gadgets, to eco-conscious costumes and famous personalities, the themes reflected creativity and purposeful learning. Children lit up the stage as cartoon characters, Bollywood stars, sports icons, and dream professionals, while others celebrated flowers and insects, transformed into Disney characters, and honoured real-life heroes as community helpers. Adding further colour and charm, some children took on everyday objects—becoming stationery items, cars, and even household items—proving that creativity knows no bounds.  Each group brought their theme to life with enthusiasm and originality, turning the classroom into a vibrant celebration of expression, learning, and joy.
       <br></br>
        <strong>Imagination on Parade: Kindergarten Fancy Dress Fiesta</strong>
        <br></br>
        The Kindergarten Fancy Dress event was a vibrant celebration of creativity, language, and learning. Each group presented thoughtfully curated themes that sparked curiosity and joy while encouraging self-expression. The youngest participants charmed the audience with lively performances based on Modern Rhymes, presented in Kannada, Hindi, and English. Children explored the beauty of the natural and social world through costumes representing vegetables, fruits, flowers, medicinal trees, special vehicles, community helpers, and musical instruments. Students also ventured into imaginative and diverse themes, exploring space, becoming superheroes, and having fun with quirky ideas like mismatched shoes and wacky hairstyles. They showcased their dramatic flair with Mad Ads, brought stories to life as storybook characters, and celebrated the richness of India through colourful representations of various states. Others impressed with a global and futuristic touch—dressing up as aquatic animals, portraying artificial intelligence concepts, and embracing elements of the digital world.  With enthusiasm, confidence, and flair, every child brought their character to life—making the day a memorable blend of fun, learning, and expressive joy.
        <br></br>
        <strong>Today we pretend, tomorrow we achieve!</strong>
        <br></br>
        Fancy Dress Day was a joyful celebration of imagination and confidence. Filled with laughter, applause, and encouragement, it offered children a safe space to express themselves. More than just a performance, it planted the seeds of creativity and self-belief—laying a strong foundation for confident communication ahead. At National Public School, Yeshwanthpur, we believe such moments nurture lifelong skills and joyful learners ready to embrace every opportunity.
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Captions: Magic happens when little ones pretend!
              Tiny voices, big characters, endless imagination!”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2025 />
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FancyDress2025;